import { Card, CardBody, CardFooter, CardHeader, CardTitle } from "reactstrap";
import { IMAGE_URL } from "../../config/Config";
import { Link } from "react-router-dom";
import TimeAgo from 'react-timeago'
import farsiStrings from 'react-timeago/lib/language-strings/fa'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'
import Label from "reactstrap/es/Label";

const formatter = buildFormatter(farsiStrings);

const TanksItem = (props) => {
    const { data } = props;

    return (
        <Card className="complain-card complain rtl" style={{ borderColor: '#4678bf' }}>
            <CardHeader className="complain-header" style={{ backgroundColor: "#4678bf" }}>
                <div className="complain-icon">
                    <i className="fas fa-grin-beam" /> پیام تشکر
                </div>
            </CardHeader>

            <CardBody>
                <div className="card-text complain-info">
                    {(data.brand !== null) ?
                        <Link to={`/brand/${data.brand.slag}`} className="complain-brand">
                            <img src={`${IMAGE_URL}${data.brand.icon}`} alt={data.brand.name} />
                            {data.brand.name}
                        </Link> :
                        <span className="complain-brand" />
                    }
                </div>

                <div className="card-text pr-2 pl-2">
                    {data.product && data.product.name &&
                        <p><Label style={{ color: "#999", fontWeight: 300 }}>اسم محصول / کد محصول : </Label> &nbsp;
                            {data.category.name} -
                            {data.product.name}</p>
                    }
                </div>

                <CardTitle className="complain-title">
                    <Link to={`/complain/${data.id}`} className="font-weight-light text-black">{data.title}</Link>
                </CardTitle>

                <p className="complain-text"
                    dangerouslySetInnerHTML={{
                        __html: data.content.length > 130 ? `${data.content.substring(0, 130)}...` : data.content
                    }}
                />

                <Link to={`/complain/${data.id}`} className="p-2">ادامه ...</Link>
            </CardBody>
            <CardFooter className="complain-footer">
                <div className="card-text complain-info">
                    {data.user ?
                        <div className="complain-user">
                            <img src={`${IMAGE_URL}${data.user.photo}`}
                                alt={data.user.first_name + " " + data.user.last_name} />
                            {data.user.first_name + " " + data.user.last_name}
                        </div> :
                        <div className="complain-user">
                            <svg width="32px" height="32px" fill="#777" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"></path></svg>
                            {data.name || "کاربر ناشناس"}
                        </div>}
                    &nbsp;&nbsp;.&nbsp;&nbsp;
                    <small><TimeAgo date={data['created']} formatter={formatter} /></small>
                </div>

                <div className="complain-comment">
                    <i className="fas fa-eye"></i> {data.visit}
                    &nbsp;&nbsp;
                    <i className="fas fa-comments"></i>{data.comment_no}
                </div>
            </CardFooter>
        </Card>
    );
};

export default TanksItem;
